import {FOCUSABLE_ELEMENTS_SELECTOR} from '../constants/focusableElementsSelector';

/**
 * Checks if an element contains any focusable children.
 *
 * This utility helps determine if an element needs to be made focusable
 * for keyboard accessibility. If the element already contains focusable
 * children, making the parent focusable would create redundant tab stops.
 *
 * @param container - The container element to check
 * @returns true if the container has focusable children, false otherwise
 *
 * @example
 * const wrapperRef = useRef<HTMLDivElement>(null);
 * const hasFocusableChildren = containsFocusableElements(wrapperRef.current);
 *
 * // Only make wrapper focusable if children aren't already focusable
 * const tabIndex = hasFocusableChildren ? undefined : 0;
 */
export const containsFocusableElements = (container: HTMLElement | null): boolean => {
  if (!container) {
    return false;
  }

  const focusableElements = container.querySelectorAll<HTMLElement>(FOCUSABLE_ELEMENTS_SELECTOR);
  return focusableElements.length > 0;
};
